import React from "react";
import { Checkbox } from "@material-ui/core";

type Props = {
  value: any;
};
export default function SingleCheckbox(props: Props) {
  const { value } = props;

  return <Checkbox checked={value === true} {...props} />;
}
